import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submit() {
    // 送適用商品type
    this.setApplicableType()
    // 送排除轉單/ingram/honya
    this.setExcludeType()
    // 送是否可參加購物車促案
    this.setCanRunWithCartPromotion()
    // 送活動類型(full_qty/full_amount)
    this.setDiscountType()
    // 送滿件數量(minimum_qty)
    this.setFullQty()
    // 送滿額數量(minimum_amount)
    this.setFullAmount()
    // 點擊single_cart_form的submit
    document.getElementById('single_cart_form_btn').click();
  }

  setApplicableType() {
    let selectedValue;
    const radios = document.querySelectorAll('input[type="radio"][name="combo_offer[applicable_type]"]');
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    })
    let hiddenFieldDiv = document.querySelector("#applicable_type");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "combo_offer[applicable_type]";
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setExcludeType(event) {
    const excludeTypes = document.querySelectorAll(`input[name='combo_offer[exclude_type]']`)
    const hiddenFieldContainer = document.getElementById("hidden_exclusive_type");
    excludeTypes.forEach((type) => {
      let value;
      if (type.checked) {
        value = true;
      } else {
        value = false;
      }

      let exclusiveTypeHiddenField = document.createElement("input");
      exclusiveTypeHiddenField.type = "hidden";
      exclusiveTypeHiddenField.name = `combo_offer[${type.value}]`;
      exclusiveTypeHiddenField.value = value;
      hiddenFieldContainer.appendChild(exclusiveTypeHiddenField);
    });
  }

  setCanRunWithCartPromotion() {
    let selectedValue = document.getElementById("run_with_cart_promotion").value;
    let hiddenFieldDiv = document.getElementById("run_with_cart_promotion_div");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "combo_offer[run_with_cart_promotion]"; // 替換成你想要的 name
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setDiscountType() {
    const radios = document.getElementsByName('full_qty_amt_discount_setting[discount_type]');
    let selectedValue
    radios.forEach((radio) => {
      if (radio.checked) {
        selectedValue = radio.value;
      }
    })
    let hiddenFieldDiv = document.getElementById("full_discount_type_div");
    const typeHiddenField = document.createElement("input");
    typeHiddenField.type = "hidden";
    typeHiddenField.name = "full_qty_amt_discount_setting[discount_type]";
    typeHiddenField.value = selectedValue;
    hiddenFieldDiv.appendChild(typeHiddenField)
  }

  setValue(fieldName, divId, hiddenFieldName) {
    let elements = document.querySelectorAll(`[name="${fieldName}"]`);
    let values = Array.from(elements).filter(element => element.value !== '').map(element => element.value);

    if (values.length > 0) {
      let hiddenFieldDiv = document.getElementById(divId);
      values.forEach(value => {
          const typeHiddenField = document.createElement("input");
          typeHiddenField.type = "hidden";
          typeHiddenField.name = `${hiddenFieldName}`;
          typeHiddenField.value = value;
          hiddenFieldDiv.appendChild(typeHiddenField)
      });
    }
  }

  setFullQty() {
    this.setValue("full_qty", "full_qty_div", "full_qty_amt_discount_setting[full_qty]");
  }

  setFullAmount() {
    this.setValue("full_amount", "full_amount_div", "full_qty_amt_discount_setting[full_amount]");
  }
}
